import { Card, CardContent } from '@/components/ui/card';
import { MapPin } from 'lucide-react';
import { Link } from '@tanstack/react-router';
import FollowButton from '@/components/FollowButton';
import { ImpersonateActionButton } from '@/components/ImpersonateActionButton';
import { StoreLogo } from '@/components/store/StoreLogo';

const StoreCardHorizontal = ({ store }) => {
  if (!store) return null;

  const location =
    [store.city?.name, store.neighborhood?.name].filter(Boolean).join(' • ') ||
    'الموقع غير متوفر';

  return (
    <Card className="overflow-hidden mb-4">
      <CardContent className="p-4">
        {/* Flex row on md+, column on mobile */}
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          {/* Left: Logo + Info */}
          <div className="flex items-center gap-3 md:justify-start justify-center">
            <div className="h-12 w-12 rounded-full overflow-hidden bg-muted flex-shrink-0">
              <StoreLogo store={store} size="thumbnail" className="w-full h-full object-cover" />
            </div>
            <div>
              <Link to={`/store/${store.slug}`} className="hover:underline">
                <h3 className="font-semibold">{store.name}</h3>
              </Link>
              <div className="flex items-center justify-center md:justify-start gap-1 text-xs text-muted-foreground">
                <MapPin className="h-3 w-3" />
                <span>{location}</span>
              </div>
            </div>
          </div>

          {/* Right: Stats + Action buttons */}
          <div className="flex flex-wrap items-center justify-center gap-4">
            <div className="text-center">
              <div className="font-semibold text-sm">{store.products_count || 0}</div>
              <div className="text-xs text-muted-foreground">منتجات</div>
            </div>
            <div className="text-center">
              <div className="font-semibold text-sm">{store.followers_count || 0}</div>
              <div className="text-xs text-muted-foreground">متابعون</div>
            </div>
            {store.is_owned ? (
              <ImpersonateActionButton
                store={store}
                to="/dashboard/"
                variant="outline"
                size="sm"
              >
                إدارة
              </ImpersonateActionButton>
            ) : (
              <FollowButton
                storeSlug={store.slug}
                initialFollowed={store.is_followed}
                size="sm"
              />
            )}
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default StoreCardHorizontal;